import { List } from 'immutable';
import { select, call, put, takeEvery, all } from 'redux-saga/effects';
import {
  SubmissionSearch,
  searchSubmissions,
  createSubmission,
  deleteSubmission,
} from '@kineticdata/react';
import { types, actions } from '../modules/attendance';
import moment from 'moment';
import { actions as errorActions } from '../modules/errors';
import { setMemberPromotionValues } from '../../components/Member/MemberUtils';

export const SUBMISSION_INCLUDES = 'details,values';
export const getMembersApp = state => state.member.members;
export const getApp = state => state.member.app;
const util = require('util');

function excludeFromAttendanceCount(additionalPrograms, className) {
  // Determine if program should exclude from Member Attendance
  var program = additionalPrograms.find(element => {
    return element['program'] === className;
  });
  return program !== undefined &&
    program['program'] === className &&
    program['exludeFromGrading'] !== undefined &&
    program['exludeFromGrading'] !== null &&
    program['exludeFromGrading'].indexOf('Exclude from Grading') !== -1
    ? true
    : false;
}

export function* fetchAttendancesByDate(action) {
  try {
    let dtFrom = moment(action.payload.fromDate);
    let dtTo = moment(action.payload.toDate);
    let allSubmissions = [];

    const search = new SubmissionSearch(true)
      .gteq('values[Class Date]', dtFrom.format('YYYY-MM-DD'))
      .lteq('values[Class Date]', dtTo.format('YYYY-MM-DD'))
      .index('values[Class Date]')
      .includes(['details', 'values'])
      .limit(1000)
      .build();

    var { submissions, nextPageToken } = yield call(searchSubmissions, {
      get: true,
      form: 'member-attendance',
      datastore: true,
      search,
    });
    allSubmissions = allSubmissions.concat(submissions);

    while (nextPageToken) {
      var search2 = new SubmissionSearch(true)
        .gteq('values[Class Date]', dtFrom.format('YYYY-MM-DD'))
        .lteq('values[Class Date]', dtTo.format('YYYY-MM-DD'))
        .index('values[Class Date]')
        .includes(['details', 'values'])
        .pageToken(nextPageToken)
        .limit(1000)
        .build();

      var [submissions2] = yield all([
        call(searchSubmissions, {
          get: true,
          form: 'member-attendance',
          datastore: true,
          search: search2,
        }),
      ]);

      allSubmissions = allSubmissions.concat(submissions2.submissions);

      if (submissions2.nextPageToken !== null) {
        nextPageToken = submissions2.nextPageToken;
      } else {
        nextPageToken = undefined;
      }
    }

    yield put(actions.setAttendancesByDate(allSubmissions));
  } catch (error) {
    console.log('Error in fetchAttendancesByDate: ' + util.inspect(error));
    yield put(errorActions.setSystemError(error));
  }
}
export function* fetchMemberClassAttendancesByDate(action) {
  try {
    let dtFrom = moment(action.payload.fromDate);
    let dtTo = moment(action.payload.toDate);
    let allSubmissions = [];

    const search = new SubmissionSearch(true)
      .eq('values[Member GUID]', action.payload.memberItem.id)
      .gteq('values[Class Date]', dtFrom.format('YYYY-MM-DD'))
      .lteq('values[Class Date]', dtTo.format('YYYY-MM-DD'))
      .index('values[Member GUID],values[Class Date]')
      .includes(['details', 'values'])
      .limit(1000)
      .build();

    var { submissions } = yield call(searchSubmissions, {
      get: true,
      form: 'member-attendance',
      datastore: true,
      search,
    });
    allSubmissions = allSubmissions.concat(submissions);
    if (action.payload.verifyMemberMaxClassesComplete)
      action.payload.verifyMemberMaxClassesComplete(
        action.payload.memberItem,
        allSubmissions,
      );
    yield put(actions.setAttendancesByDate(allSubmissions));
  } catch (error) {
    console.log(
      'Error in fetchMemberAttendancesByDate: ' + util.inspect(error),
    );
    yield put(errorActions.setSystemError(error));
  }
}
export function* fetchClassAttendances(action) {
  try {
    let dt = moment(action.payload.classDate);

    const search = new SubmissionSearch(true)
      .eq('values[Class Date]', dt.format('YYYY-MM-DD'))
      .index('values[Class Date]')
      .includes(['details', 'values'])
      .limit(1000)
      .build();

    const { submissions } = yield call(searchSubmissions, {
      get: true,
      form: 'member-attendance',
      datastore: true,
      search,
    });
    const membersApp = yield select(getMembersApp);
    const app = yield select(getApp);
    submissions.forEach(attendance => {
      let memberItem = undefined;
      for (let i = 0; i < membersApp.allMembers.length; i++) {
        if (membersApp.allMembers[i].id === attendance.values['Member GUID']) {
          memberItem = membersApp.allMembers[i];
          setMemberPromotionValues(memberItem, app.belts);
          break;
        }
      }
      if (memberItem === undefined) {
        attendance.values['First Name'] = 'Member Deleted';
      } else {
        attendance.values['Photo'] = memberItem.values['Photo'];
        attendance.values['First Name'] = memberItem.values['First Name'];
        attendance.values['Last Name'] = memberItem.values['Last Name'];
        attendance.values['Waiver Complete Date'] =
          memberItem.values['Waiver Complete Date'];

        attendance.programOrder = memberItem.programOrder;
        attendance.promotionSort = memberItem.promotionSort;
        attendance.statusText = memberItem.statusText;
        attendance.attendClasses = memberItem.attendClasses;
        attendance.durationPeriod = memberItem.durationPeriod;
        attendance.attendanceVal = memberItem.attendanceVal;
        attendance.daysElapsed = memberItem.daysElapsed;
        attendance.daysVal = memberItem.daysVal;
        attendance.attendancePerc = memberItem.attendancePerc;
        attendance.statusIndicator = memberItem.statusIndicator;
        attendance.memberItem = memberItem;
      }
    });

    yield put(actions.setClassAttendances(submissions));
  } catch (error) {
    console.log('Error in fetchClassAttendances: ' + util.inspect(error));
    yield put(errorActions.setSystemError(error));
  }
}
export function* fetchMemberAttendances(action) {
  try {
    const search = new SubmissionSearch(true)
      .eq('values[Member GUID]', action.payload.id)
      .gteq('values[Class Date]', action.payload.fromDate)
      .lteq('values[Class Date]', action.payload.toDate)
      .index('values[Member GUID],values[Class Date]')
      .includes(['details', 'values'])
      .limit(1000)
      .build();

    const { submissions } = yield call(searchSubmissions, {
      get: true,
      form: 'member-attendance',
      datastore: true,
      search,
    });

    yield put(actions.setMemberAttendances(submissions));
  } catch (error) {
    console.log('Error in fetchMemberAttendances: ' + util.inspect(error));
    yield put(errorActions.setSystemError(error));
  }
}
export function* createAttendance(action) {
  try {
    var memberItem;
    var attendanceSubmission;

    // Snapshot whether this attendance record already exists locally before submission.
    // Used below to distinguish a genuine first check-in from a deliberate double-tap.
    const alreadyLocal = action.payload.classAttendances.some(
      ca =>
        ca.values['Member GUID'] === action.payload.values['Member GUID'] &&
        ca.values['Class Date'] === action.payload.values['Class Date'] &&
        ca.values['Class Time'] === action.payload.values['Class Time'],
    );

    const { submission, error } = yield call(createSubmission, {
      datastore: true,
      formSlug: 'member-attendance',
      values: action.payload.values,
      completed: true,
      include: SUBMISSION_INCLUDES,
    });
    for (let i = 0; i < action.payload.allMembers.length; i++) {
      if (
        action.payload.allMembers[i].id === action.payload.values['Member GUID']
      ) {
        memberItem = action.payload.allMembers[i];
        break;
      }
    }
    const app = yield select(getApp);
    setMemberPromotionValues(memberItem, app.belts);

    if (error !== undefined && error.key === 'uniqueness_violation') {
      // Retrieve actual record.
      const search = new SubmissionSearch(true)
        .eq('values[Member GUID]', action.payload.values['Member GUID'])
        .eq('values[Class Date]', action.payload.values['Class Date'])
        .eq('values[Class Time]', action.payload.values['Class Time'])
        .index('values[Class Date],values[Class Time],values[Member GUID]')
        .includes(['details', 'values'])
        .build();

      const { submissions } = yield call(searchSubmissions, {
        get: true,
        form: 'member-attendance',
        datastore: true,
        search,
      });
      attendanceSubmission = submissions[0];
      action.payload.attendance['id'] = attendanceSubmission.id;

      attendanceSubmission.values['Photo'] = memberItem.values['Photo'];
      attendanceSubmission.values['First Name'] =
        memberItem.values['First Name'];
      attendanceSubmission.values['Last Name'] = memberItem.values['Last Name'];
      attendanceSubmission.values['Waiver Complete Date'] =
        memberItem.values['Waiver Complete Date'];

      attendanceSubmission.programOrder = memberItem.programOrder;
      attendanceSubmission.promotionSort = memberItem.promotionSort;
      attendanceSubmission.statusText = memberItem.statusText;
      attendanceSubmission.attendClasses = memberItem.attendClasses;
      attendanceSubmission.durationPeriod = memberItem.durationPeriod;
      attendanceSubmission.attendanceVal = memberItem.attendanceVal;
      attendanceSubmission.daysElapsed = memberItem.daysElapsed;
      attendanceSubmission.daysVal = memberItem.daysVal;
      attendanceSubmission.attendancePerc = memberItem.attendancePerc;
      attendanceSubmission.statusIndicator = memberItem.statusIndicator;
    } else {
      attendanceSubmission = submission;
      action.payload.attendance['id'] = attendanceSubmission.id;

      attendanceSubmission.values['Photo'] = memberItem.values['Photo'];
      attendanceSubmission.values['First Name'] =
        memberItem.values['First Name'];
      attendanceSubmission.values['Last Name'] = memberItem.values['Last Name'];
      attendanceSubmission.values['Waiver Complete Date'] =
        memberItem.values['Waiver Complete Date'];

      attendanceSubmission.programOrder = memberItem.programOrder;
      attendanceSubmission.promotionSort = memberItem.promotionSort;
      attendanceSubmission.statusText = memberItem.statusText;
      attendanceSubmission.attendClasses = memberItem.attendClasses;
      attendanceSubmission.durationPeriod = memberItem.durationPeriod;
      attendanceSubmission.attendanceVal = memberItem.attendanceVal;
      attendanceSubmission.daysElapsed = memberItem.daysElapsed;
      attendanceSubmission.daysVal = memberItem.daysVal;
      attendanceSubmission.attendancePerc = memberItem.attendancePerc;
      attendanceSubmission.statusIndicator = memberItem.statusIndicator;
    }

    // Only increment attendanceCount if this is a genuinely new check-in for this session.
    // alreadyLocal=true means the staff deliberately tapped twice — don't double-count.
    // alreadyLocal=false covers both clean first-time check-ins AND the network-retry
    // scenario (server created the record, client timed out, retry gets uniqueness_violation).
    if (!alreadyLocal) {
      // Only increment if this is the member's first class of the day
      let checkin = action.payload.classAttendances.find(
        checkin =>
          checkin.values['Member GUID'] ===
            attendanceSubmission.values['Member GUID'] &&
          moment(checkin.values['Class Date']).format('MM/DD/YYYY') ===
            moment(action.payload.classDate).format('MM/DD/YYYY') &&
          !excludeFromAttendanceCount(
            action.payload.additionalPrograms,
            checkin.values['Class'],
          ),
      );
      if (
        checkin === undefined &&
        !excludeFromAttendanceCount(
          action.payload.additionalPrograms,
          action.payload.values['Class'],
        )
      ) {
        let attendanceCount =
          memberItem.values['Attendance Count'] !== undefined &&
          memberItem.values['Attendance Count'] !== null
            ? parseFloat(
                parseFloat(memberItem.values['Attendance Count']).toFixed(2),
              )
            : 0;
        attendanceCount += 1;
        memberItem.values['Attendance Count'] = attendanceCount;

        let lastAttendanceDate = moment(
          action.payload.values['Class Date'],
        ).isAfter(moment(memberItem.values['Last Attendance Date']))
          ? moment(action.payload.values['Class Date'])
          : moment(memberItem.values['Last Attendance Date']);

        memberItem.values['Last Attendance Date'] = lastAttendanceDate.format(
          'YYYY-MM-DD',
        );

        var values = {};
        values['Attendance Count'] = attendanceCount;
        values['Last Attendance Date'] = lastAttendanceDate.format(
          'YYYY-MM-DD',
        );
        action.payload.updateMember({
          id: memberItem['id'],
          memberItem: memberItem,
          values: values,
          myThis: action.payload.myThis,
        });
      }
    }
    var values = [];
    values['Member GUID'] = memberItem.id;

    action.payload.classAttendances[
      action.payload.classAttendances.length
    ] = attendanceSubmission;
    yield put(
      actions.setAddAttendance({
        id: attendanceSubmission.id,
        values: values,
        name:
          memberItem.values['First Name'] +
          ' ' +
          memberItem.values['Last Name'],
        class: action.payload.values['Class'],
      }),
    );
    yield put(actions.setClassAttendances(action.payload.classAttendances));
  } catch (errorMessage) {
    console.log('Error in createAttendance: ' + util.inspect(errorMessage));
    yield put(errorActions.setSystemError(errorMessage));
  }
}

export function* deleteAttendance(action) {
  try {
    console.log('deleteAttendance: ');
    const { errors, serverError } = yield call(deleteSubmission, {
      id: action.payload.attendance.id,
      datastore: true,
    });

    let attendances = [];
    if (action.payload.classAttendances !== undefined) {
      for (let i = 0; i < action.payload.classAttendances.length; i++) {
        if (
          action.payload.classAttendances[i].id !== action.payload.attendance.id
        ) {
          attendances[attendances.length] = action.payload.classAttendances[i];
        }
      }
      let memberItem = undefined;
      for (let i = 0; i < action.payload.allMembers.length; i++) {
        if (
          action.payload.allMembers[i].id ===
          action.payload.attendance.values['Member GUID']
        ) {
          memberItem = action.payload.allMembers[i];
          break;
        }
      }

      // Only Decrement attendanceCount if no classes for the day
      let checkin = attendances.find(
        checkin =>
          checkin.values['Member GUID'] ===
            action.payload.attendance.values['Member GUID'] &&
          moment(checkin.values['Class Date']).format('MM/DD/YYYY') ===
            moment(action.payload.classDate).format('MM/DD/YYYY') &&
          !excludeFromAttendanceCount(
            action.payload.additionalPrograms,
            checkin.values['Class'],
          ),
      );
      if (
        checkin === undefined &&
        !excludeFromAttendanceCount(
          action.payload.additionalPrograms,
          action.payload.attendance.values['Class'],
        )
      ) {
        let attendanceCount =
          memberItem.values['Attendance Count'] !== undefined
            ? parseFloat(
                parseFloat(memberItem.values['Attendance Count']).toFixed(2),
              )
            : 0;
        attendanceCount -= 1;
        memberItem.values['Attendance Count'] = attendanceCount;

        var values = {};
        values['Attendance Count'] = attendanceCount;
        action.payload.updateMember({
          id: memberItem['id'],
          memberItem: memberItem,
          values: values,
          myThis: action.payload.myThis,
        });
      }
      console.log('attendances:' + attendances.length);
      yield put(actions.setClassAttendances(attendances));
    }
  } catch (error) {
    console.log('Error in deleteAttendance: ' + util.inspect(error));
    yield put(errorActions.setSystemError(error));
  }
}

export function* watchAttendance() {
  yield takeEvery(types.CREATE_ATTENDANCE, createAttendance);
  yield takeEvery(types.DELETE_ATTENDANCE, deleteAttendance);
  yield takeEvery(types.FETCH_CLASS_ATTENDANCES, fetchClassAttendances);
  yield takeEvery(types.FETCH_MEMBER_ATTENDANCES, fetchMemberAttendances);
  yield takeEvery(types.FETCH_ATTENDANCES_BY_DATE, fetchAttendancesByDate);
  yield takeEvery(
    types.FETCH_MEMBER_CLASS_ATTENDANCES_BY_DATE,
    fetchMemberClassAttendancesByDate,
  );
}
